export const STATIC_PATTERNS = {
  grid: '/patterns/grid-pattern.png',
  dots: '/patterns/pattern.svg'
}; 